import { Checkbox, FormControl, FormControlLabel, Grid, InputAdornment, InputLabel, MenuItem, Select, TextField, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import classNames from 'classnames';
import React, { useState } from 'react'
import { formatFloat, parseAPIFloat } from '../utils/util';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';

const useStyles = makeStyles((theme) => ({
    input_container: {
        padding: theme.spacing(1) + ' 0'
    },
    checkbox_container: {
        padding: theme.spacing(1),
        paddingTop: theme.spacing(0.5),
        paddingBottom: theme.spacing(0.5),
    },
    select_container: {
        marginTop: theme.spacing(0.4)
    },

    select_input: {
        padding: '10.5px 18.5px 10.5px 18.5px!important',
    },
    input: {
        marginTop: theme.spacing(0.5),
        color: theme.palette.common.white,
    },
    inputContainer: {
        border: '2px solid',
        borderColor: theme.palette.primary.main,
        borderRadius: theme.spacing(3),
        height: '40px',
    },
    inputContainerFocus: {
        border: '2px solid ' + theme.palette.primary.main,
    },
    inputRoot: {
        //color: theme.palette.common.white + "!important",
    },
    textArea: {
        // minHeight: theme.spacing(24),
        height: 'auto',
    },
    //add css underline, 
    underline: {
        "&&&:before": {
            borderBottom: "none",
            borderTop: "none",
        },
        "&&:after": {
            borderBottom: "none",
            borderTop: "none",
        }
    },
    customInputOutline: {
        border: 0,
    }
}));
function TextFieldComponent({
    input: { name, onChange, value, inputlabelprops, type, ...restInput },
    disabled, label, color, isEdit, placeholder, dataType, formatType, multiline, rows, valuez, autoFocus,
    meta, inputCss, startAdornment, endAdornment, leftIconAction, leftIconColor, leftIconActionDisabled,
    onCustomChange, maxLength, startPrefix, large, disableEndAdornment, rightLabelComponent, isValueNull, onCustomOnBlur,
    ...rest
}) {
    const classes = useStyles();
    let fieldFormat = rest.fieldFormat;
    let fieldParse = rest.fieldParse;
    let fieldParseOnBlur = rest.fieldParseOnBlur;

    if (formatType === 'float') {
        fieldFormat = formatFloat;
        fieldParse = parseFloat;
        fieldParseOnBlur = parseAPIFloat;
    }
    
    if(valuez){
        onChange(valuez);
    }
    
    let _onChange = event => {
        if (onCustomChange) {
            onCustomChange(event.target.value);
        }
        if (rest && fieldFormat == formatFloat && fieldParse == parseFloat) {
            event.persist();
            const caretStart = event.target.selectionStart;
            let value = event.target.value;
            let parsedValue = fieldParse ? fieldParse(event.target.value) : value;
            let formatedValue = parsedValue;
            if (fieldFormat) {
                formatedValue = fieldFormat(formatedValue);
            }
            let newCaretStart = caretStart + formatedValue.length - value.length;
            // if (newCaretStart == caretStart && caretStart >0)
            //     newCaretStart = newCaretStart + 1;
            //console.log(value, parsedValue);
            //console.log('111111111111', caretStart, formatedValue.length, value.length, newCaretStart)
            onChange(parsedValue);
            window.requestAnimationFrame(() => {
                event.target.selectionStart = newCaretStart
                event.target.selectionEnd = newCaretStart
            })
        } else {
            if (fieldParse)
                onChange(fieldParse(event.target.value));
            else
                onChange(event);
        }

    }

    let _onBlur = event => {
        let trimmedVal = value;
        if (value)
            trimmedVal = value.toString().trim();
        if (fieldParseOnBlur) {
            onChange(fieldParseOnBlur(trimmedVal))
        } else
            onChange(trimmedVal);
    }

    let formattedValue = fieldFormat ? fieldFormat(value) : value;
    return (
        <Grid xs={12} sm={12} item className={classes.input_container}>
            <Grid xs={12} sm={12} item container>
                <Typography variant="body2">
                    {label}
                </Typography>
            </Grid>
            <TextField
                id="input-with-icon-textfield"
                type={type ? type : undefined}
                size="small"
                autoComplete="false"//warning in chrome, so change string "false"
                // autoCorrect={false}//warning in chrome, so remove it
                value={isValueNull ? '' : (valuez ? valuez: formattedValue)}
                onChange={_onChange}
                onBlur={onCustomOnBlur ? onCustomOnBlur : _onBlur}
                fullWidth
                disabled={disabled}
                className={classes.input}
                multiline={multiline}
                rows={rows}
                placeholder={placeholder}
                autoFocus={autoFocus}
                InputProps={{
                    // disableUnderline:true,//warning in chrome, so remove it
                    //check with color
                    classes: { root: classes.inputContainer, 
                        input: color ? color : classes.inputRoot,
                        focused: classes.inputContainerFocus, 
                        underline: classes.underline,
                        multiline: classes.textArea,
                        notchedOutline: classes.customInputOutline,
                     },
                    startAdornment: (
                        <InputAdornment position="start">
                            {startAdornment}
                        </InputAdornment>
                    ),
                    endAdornment: (
                        <InputAdornment position="end">
                            {endAdornment}
                        </InputAdornment>
                    ),
                }}
            />

            {meta.touched && meta.error && <Typography color="error" variant="caption">{meta.error}</Typography>}
        </Grid>

    )
}

function CheckboxComponent({
    input: { name, onChange, value, checked, inputlabelprops, ...restInput },
    meta, label, isEdit, isChecked, isNotShowError, values, disableCss, lableCSS, customLabel, alignItems,
    onChangeCustom, changeCustom, checkbox_custom,
    ...rest
}) {
    const classes = useStyles();
    return (
        <FormControlLabel
            className={changeCustom ? checkbox_custom : classes.checkbox_container}
            control={
                <Checkbox
                    checked={checked}
                    onChange={changeCustom ? onChangeCustom : onChange}
                    name={name}
                    color="primary"
                />
            }
            label={label}
        />

    )
}

function SelectBoxComponent({
    input: { name, onChange, value, inputlabelprops, type, ...restInput },
    onCustomChange, disabled, meta, label, color, isEdit, placeholder, rightLabelComponent, options, itemDisplay, itemValue, showNulValue, valuez, defaultValue, titleNullValue, ...rest
}) {
    const classes = useStyles();
    console.log("select value: ", value);
    return (
        <Grid xs={12} sm={12} item className={classes.input_container}>
            {/* <Grid xs={12} sm={12} item container>
                <Typography variant="body2">
                    {label}
                </Typography>
            </Grid> */}
            <FormControl fullWidth variant="outlined">
                {!value && <InputLabel id="custom-select-label">{placeholder ? placeholder : "Please Select"}</InputLabel>}
                <Select
                    labelId="custom-select-label"
                    id="custom-select"
                    fullWidth
                    disabled={disabled}
                    onChange={e => {
                        onChange(e);
                        if (onCustomChange)
                            onCustomChange(e)
                    }}
                    defaultValue={defaultValue ? defaultValue : value}
                    value={valuez ? valuez : value}
                    helperText={meta.touched ? meta.error : undefined}
                    error={meta.error && meta.touched}
                    className={classes.select_container}
                    inputProps={{ className: classes.select_input }}
                    label={label ? label : null}
                >
                    {showNulValue && <MenuItem value="">
                        <Typography variant={'body2'}>{titleNullValue}</Typography>
                    </MenuItem>}
                    {options.length > 0 && options.map((item, index) => {
                        return <MenuItem key={index} value={item[itemValue]}>{item[itemDisplay]}</MenuItem>
                    })}
                </Select>
            </FormControl>
            {meta.touched && meta.error && <Typography color="error" variant="caption">{meta.error}</Typography>}
        </Grid>

    )
}


function DatePickerCustom({ input: { name, onChange, value, inputlabelprops, ...restInput }, valuez, onCustomChange, formatDate, views,
    meta, label, isEdit, color, dataType, ...rest }) {
    const [formattedValue, setFormattedValue] = useState("");

    const classes = useStyles();
    console.log("value ===", value);
    console.log("formatDate: ", formatDate);

    return (
        <Grid xs={12} item className={classes.padding}>
            {label && <Typography color={color}>{label}</Typography>}
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <MobileDatePicker
                    // label="Date mobile"
                    inputFormat={formatDate ? formatDate : "DD/MM/YYYY"}
                    value={value ? value : null}
                    // mask={value =>
                    //     value
                    //         ? [/\d/, /\d/, ".", /\d/, /\d/, ".", /\d/, /\d/, /\d/, /\d/]
                    //         : []
                    // }
                    views={views}
                    onChange={date => {
                        onChange(date);
                        setFormattedValue(date.format(formatDate ? formatDate : "DD/MM/YYYY"));
                        if (onCustomChange) onCustomChange(date);
                    }}
                    renderInput={(params) => <TextField
                        {...params}
                        value={formattedValue ? formattedValue : valuez}
                        onInputChange={event => setFormattedValue(event.target.value)}
                        className={classes.inputLine}
                        placeholder={formatDate ? formatDate : "DD/MM/YYYY"}
                        inputProps={classes.customPadding}
                        InputProps={{
                            disableUnderline: true,
                            classes: { root: color ? classNames(classes.inputRoot, classes[color]) : classes.inputRoot },
                        }}
                        helperText={meta.touched ? meta.error : undefined}
                        error={meta.error && meta.touched}
                    />}
                />
            </LocalizationProvider>
        </Grid>
    );
}

export {
    TextFieldComponent,
    CheckboxComponent,
    SelectBoxComponent,
    DatePickerCustom,
};